<div class="flex-column gap pt-2">
    <app-date-input
        [form]="form"
        [prefix]="prefix"
        id="validFrom">
    </app-date-input>
    <app-date-input
        [form]="form"
        [prefix]="prefix"
        id="validTo">
    </app-date-input>
    <app-workplace-select
        [form]="form"
        label="workplace.label"
        [serviceId]="store.serviceId()"
    ></app-workplace-select>

    @if (isNotClosestWorkplace()) {
        <app-warn-float-message message="folder.workplace.notClosestWarning"></app-warn-float-message>
    }
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        (primaryClickEvent)="save()"
        (secondaryClickEvent)="dialogRef.close()"
    ></app-action-buttons>
</div>
